"use strict";
exports.__esModule = true;
var lng_lat_1 = require("../geometry/lng-lat");
var bounds_1 = require("../geometry/bounds");
var point_1 = require("../geometry/point");
exports.sphericalMercator = {
    R: 6378137,
    MAX_LATITUDE: 85.0511287798,
    /**
     * 经纬度坐标转平面坐标
     * @param lnglat 经纬度
     */
    project: function (lnglat) {
        var d = Math.PI / 180;
        var max = this.MAX_LATITUDE;
        var lat = Math.max(Math.min(max, lnglat.lat), -max);
        var sin = Math.sin(lat * d);
        return new point_1.Point(this.R * lnglat.lng * d, (this.R * Math.log((1 + sin) / (1 - sin))) / 2);
    },
    // 平面坐标转经纬度
    unproject: function (point) {
        var d = 180 / Math.PI;
        return new lng_lat_1.LngLat((point.x * d) / this.R, (2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d);
    },
    bounds: (function () {
        var d = 6378137 * Math.PI;
        return new bounds_1.Bounds([-d, -d], [d, d]);
    })()
};
//# sourceMappingURL=spherical-mercator.js.map